export const localeMapping = {
  de: 'de_DE',
  en: 'en_GB',
  es: 'es_ES',
  tr: 'tr_TR',
  uk: 'uk_UA',
};
